import {PageFragment, PageFragmentProps, PageFragmentState} from "@/shared/PageFragment";
import React, {ReactElement} from "react";
import {StyledBoxColumn, StyledEmpty} from "@/shared/StyledComponents";
import {Action, ACTION_SPACE, ActionBase} from "@/shared/types";
import {BaseListFragment} from "@/shared/BaseListFragment";
import {Button, Grid, Typography} from "@mui/material";
import {CARD_SHADOW, PD_LG, PD_XLG} from "@/shared/dimens";
import {AddOutlined} from "@mui/icons-material";
import {PathComponent} from "@/shared";
import {Outlet} from "react-router-dom";
import {LabelerDataset, LabelerDatasets, ResourceData} from "@/fyneai-shared/types";
import defaultDatasetImage from "./res/images/default_dataset.png";
import {DatasetFragment} from "./DatasetFragment";
import {EditDatasetHelper} from "./EditDatasetHelper";
import datasetImage from "./res/images/dataset.svg";

export type DatasetsFragmentProps = PageFragmentProps & {}

type DatasetsFragmentState = PageFragmentState & {}

export class DatasetsFragment extends BaseListFragment<LabelerDataset, LabelerDatasets, DatasetsFragmentProps, DatasetsFragmentState> {

  static nestedPaths(): PathComponent[] {
    return [
      {
        path: ":dataset_id",
        children: DatasetFragment.nestedPaths(),
        render: pathProps => <DatasetFragment
          datasetId={pathProps.params.dataset_id}
          path={pathProps}
          onBack={() => pathProps.navigate("../")}
        />,
      },
    ];
  }

  private readonly actions: ActionBase[] = [
    ACTION_SPACE,
    new Action("New Dataset", () => {
      EditDatasetHelper.addDataset();
    }, AddOutlined)
      .setVariant("contained"),
  ];

  constructor(props: DatasetsFragmentProps, context: any) {
    super(props, context, ResourceData.project().labeler.datasets);
  }

  protected getTitle(): string | null | undefined {
    return "Datasets";
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  protected getToolbar(toolbarModeId: string | null): React.ReactElement {
    return this.renderToolbarButtonsInToolbarContainerEx(this.actions);
  }

  protected renderContainerContent(): React.ReactElement | null {
    if (this.props.path.params.dataset_id) {
      return <Outlet/>;
    }
    return super.renderContainerContent();
  }

  renderContent(): ReactElement {
    const items = this.loader.getListItems();
    if (!(items?.length > 0)) {
      return <StyledEmpty emptyConfig={{
        title: "Create a new dataset",
        text: "You can add multiple tasks and assign them for labeling.",
        iconUrl: datasetImage,
        action: new Action("Create a dataset", () => EditDatasetHelper.addDataset()),
      }}/>;
    }
    return <div style={{width: "100%", padding: PD_LG}}>
      <Grid container>
        {items.map(item => <Grid xs={12} sm={6} md={4} lg={3}>
          <div style={{width: "100%", height: "100%", padding: PD_LG}}>
            <Button
              onClick={() => this.props.path.navigate(`${item.id}`)}
              style={{width: "100%", height: "100%", boxShadow: CARD_SHADOW}}>
              <StyledBoxColumn style={{width: "100%", flexGrow: 1, padding: PD_XLG}}>
                <img src={defaultDatasetImage}
                     style={{width: "100%", aspectRatio: 1, objectFit: "contain"}}/>
                <Typography>{item.name}</Typography>
              </StyledBoxColumn>
            </Button>
          </div>
        </Grid>)}
      </Grid>
    </div>;
  }
}